const getLinkToPublishedContent = (key = '', props = {}, currentValue = null) => {
  const [baseKey] = key.split('.');
  if (!props[baseKey]) return '';
  if (currentValue && typeof currentValue.url !== 'undefined') return currentValue.url;
  const content = Array.isArray(props[baseKey]) ? props[baseKey][0] : props[baseKey];
  return content && content.url ? content.url : '';
};
export default getLinkToPublishedContent;
//# sourceMappingURL=get-link-to-published-content.js.map